import { useStore } from "../store/Store";
import Footer from "../components/Footer";

export default function ReturnsPage({ onNav }) {
  const { adminWhatsApp: WA_NUM } = useStore();

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 28 }}>
      <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:700, color:"#1a1a2e", marginBottom:10 }}>{title}</h3>
      <div style={{ fontSize:14, color:"#555", lineHeight:1.8 }}>{children}</div>
    </div>
  );

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"28px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,34px)", fontWeight:900, color:"white" }}>Return & Exchange Policy</h1>
        <p style={{ fontSize:12, color:"rgba(255,255,255,0.7)", marginTop:6 }}>Last updated: {new Date().toLocaleDateString("en-IN",{year:"numeric",month:"long",day:"numeric"})}</p>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"clamp(24px,5vw,48px) clamp(16px,4vw,40px)" }}>
        <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"12px 16px", fontSize:12, color:"#92400E", marginBottom:28 }}>
          ⚠️ Ye ek starting template hai — apne actual return timelines/rules ke hisaab se numbers adjust kar lena.
        </div>

        <Section title="1. Easy 7-Day Returns">
          We offer a 7-day return window from the date of delivery for most items, provided they are unused, unwashed,
          and returned with original tags and packaging intact.
        </Section>

        <Section title="2. Items That Cannot Be Returned">
          For hygiene reasons, the following cannot be returned or exchanged:
          <ul style={{ marginTop:8, paddingLeft:20 }}>
            <li>Fabric sold by the metre (cut-to-order)</li>
            <li>Items marked "Final Sale" or purchased during clearance</li>
            <li>Products with tags removed or signs of wear</li>
          </ul>
        </Section>

        <Section title="3. How to Request a Return or Exchange">
          Tap "↩️ Return" next to your order on the <span onClick={()=>onNav("orders")} style={{color:"#EC4899",cursor:"pointer",fontWeight:700}}>My Orders</span> page,
          or message us directly on WhatsApp with your Order ID and reason. Our team will guide you through the pickup process.
        </Section>

        <Section title="4. Refunds">
          Once we receive and inspect the returned item, refunds are processed to your original payment method within
          5-7 business days. For Cash on Delivery orders (where applicable), refunds are made via UPI/bank transfer.
        </Section>

        <Section title="5. Damaged or Wrong Item Received">
          If you receive a damaged product or the wrong item, please contact us within 48 hours of delivery with photos
          of the product — we'll arrange a free replacement or full refund, no questions asked.
        </Section>

        <Section title="6. Exchange for a Different Size">
          Need a different size? Let us know via WhatsApp within 7 days of delivery and we'll arrange an exchange,
          subject to stock availability.
        </Section>

        <Section title="7. Need Help?">
          <a href={`https://wa.me/${WA_NUM}?text=${encodeURIComponent("Hi, I need help with a return/exchange.")}`} target="_blank" rel="noreferrer"
            style={{ display:"inline-flex", alignItems:"center", gap:8, background:"#F0FDF4", border:"1px solid #86EFAC", padding:"10px 20px", borderRadius:50, color:"#16A34A", fontWeight:700, textDecoration:"none", fontSize:13 }}>
            💬 Chat with us on WhatsApp
          </a>
        </Section>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
